import PhotoGrayIcon from '@assets/images/common/image_dummy.svg';
import { EventIndexResponseData } from '@src/api/company/event/eventApiClient.ts';
import { RECEPTION_STATUS } from '@src/enum/receptionStatus.ts';
import { COMPANY_URL } from '@src/routes/company.tsx';
import Tag from '@src/ui/elements/Company/Tag';
import generateUrlWithParams from '@src/utils/generateUrlWithParams';
import React from 'react';
import { generatePath, Link } from 'react-router-dom';

interface EventsItemProps {
  event: EventIndexResponseData;
}

const EventsItem: React.FC<EventsItemProps> = ({ event }) => {
  const eventUrl = generatePath(COMPANY_URL.EVENTS_SHOW, { id: event.id });
  return (
    <article>
      <Link
        to={eventUrl}
        className='block transition-opacity hover:opacity-80'
      >
        <img
          className='aspect-[300/168] size-full object-contain'
          src={event.thumbnail_url || PhotoGrayIcon}
          alt=''
          width={300}
          height={168}
          loading='lazy'
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = PhotoGrayIcon;
          }}
        />
      </Link>
      <div className='mt-5 flex items-center justify-between gap-3'>
        {event.reception_status === RECEPTION_STATUS.BEFORE_RECRUITING ? (
          <span className='flex-[0_0_auto] rounded border border-solid border-primary px-2 py-0.5 text-sm text-primary'>
            受付開始前
          </span>
        ) : event.reception_status === RECEPTION_STATUS.RECRUITING ? (
          <span className='flex-[0_0_auto] rounded bg-primary px-2 py-0.5 text-sm text-white'>
            受付中
          </span>
        ) : event.reception_status === RECEPTION_STATUS.CLOSED ? (
          <span className='flex-[0_0_auto] rounded bg-gray-200 px-2 py-0.5 text-sm'>受付終了</span>
        ) : (
          <span></span>
        )}

        <div className='order-1 flex items-center gap-4'>
          <Link
            to={generateUrlWithParams(COMPANY_URL.EVENTS, {
              category_slug: event.media_category.slug,
            })}
            className='border-b-2 border-primary-500 py-1 text-sm text-primary transition-opacity hover:opacity-80'
          >
            {event.media_category.name}
          </Link>
        </div>
      </div>
      <div className='mt-4 flex items-center gap-2 lg:text-sm'>
        <span className='border border-solid border-gray-200 px-2 py-0.5'>開催期間</span>
        {event.event_start_at !== event.event_end_at ? (
          <div className='flex items-center gap-1 font-semibold'>
            <span className=''>{event.event_start_at}</span>
            <span>〜</span>
            <span className=''>{event.event_end_at}</span>
          </div>
        ) : (
          <div className='flex items-center gap-1 font-semibold'>
            <span className=''>{event.event_start_at}</span>
          </div>
        )}
      </div>
      <div className='mt-1 flex w-full flex-col'>
        <Link
          to={eventUrl}
          className='block transition-opacity hover:opacity-80'
        >
          <h2 className='order-2 mt-4 line-clamp-1 break-all text-xl font-semibold md:line-clamp-2'>
            {event.title}
          </h2>
        </Link>
        <div className='order-3 mt-2 line-clamp-2 break-all text-sm leading-7'>{event.content}</div>
        <ul className='order-4 mt-3 flex flex-wrap gap-2 pt-1'>
          {event.media_tags.map((tag, index) => (
            <Tag
              key={index}
              to={generateUrlWithParams(COMPANY_URL.EVENTS, {
                tag_slug: tag.slug || '',
              })}
              label={tag.name}
            />
          ))}
        </ul>
      </div>
    </article>
  );
};

export default EventsItem;
